import { render } from "./Orders.vue?vue&type=template&id=36c3bb78&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=36c3bb78&lang=scss&scoped=true"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c3bb78"],['__file',"resources/js/views/Orders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36c3bb78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36c3bb78', __exports__)) {
    console.log('reload')
    api.reload('36c3bb78', __exports__)
  }
  
  module.hot.accept("./Orders.vue?vue&type=template&id=36c3bb78&scoped=true", () => {
    console.log('re-render')
    api.rerender('36c3bb78', render)
  })

}


export default __exports__